import { render, staticRenderFns } from "./Children.vue?vue&type=template&id=6d68887c&scoped=true"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"
import style0 from "./Children.vue?vue&type=style&index=0&id=6d68887c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68887c",
  null
  
)

export default component.exports